import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDBox, FDHeadlineText, FDStack, FDTitleText,
} from '@facet-wealth/design';
import { PercentFormatter, USDCurrencyFullFormatterNoFraction } from 'Helpers/Formats';
import Divider from 'Components/UI/Divider';
import { FacetLogoHorizontal } from 'Icons/FacetLogo';
import Typography from 'Components/UI/Typography';
import LinearProgress from 'Components/UI/LinearProgress';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('OurInterestComparedWithNationalAverage', (theme) => ({
  nationalAverageBarColorPrimary: {
    backgroundColor: 'transparent',
  },
  nationalAverageBarBarColorPrimary: {
    backgroundColor: theme.palette.facet.primaryGray4,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
}));

export function OurInterestComparedWithNationalAverage({ resource }) {
  const classes = useStyles();
  const apy = `${PercentFormatter.format(resource.attr('apy'))}% APY`;
  const nationalAPY = `${PercentFormatter.format(resource.attr('nationalAverageAPY'))}% APY*`;
  const apyRatio = Number(resource.attr('apyRatio'));
  return (
    <FDStack direction={'column'} spacing={2} alignItems="flex-start" justifyContent="flex-start">
      <FDBox width={'100%'}>
        <FDStack spacing={2} justifyContent={'space-between'} alignItems={'center'}>
          <FDTitleText value={'Interest earned per year on'} />
          <FDBox><FDHeadlineText value={USDCurrencyFullFormatterNoFraction.format(resource.attr('examplePrincipal'))} /></FDBox>
        </FDStack>
      </FDBox>

      <FDBox width={'100%'}><Divider /></FDBox>

      <FDBox width={'100%'}>
        <FDStack spacing={2} justifyContent={'space-between'} alignItems={'center'}>
          <FDBox width={'120px'}>
            <FDStack direction={'column'} alignItems={'flex-end'} justifyContent="flex-start" spacing={1}>
              <img src={FacetLogoHorizontal} alt={'Facet'} />
              <Typography color={'textSecondary'} variant={'h6'}>{apy}</Typography>
            </FDStack>
          </FDBox>
          <div style={{ flex: 1 }}>
            <LinearProgress ProgressProps={{ variant: 'determinate', value: 100 }} />
          </div>
          <FDBox><FDTitleText size={'lg'} value={USDCurrencyFullFormatterNoFraction.format(resource.attr('interestEarnedFacet'))} /></FDBox>
        </FDStack>
      </FDBox>

      <FDBox width={'100%'}>
        <FDStack spacing={2} justifyContent={'space-between'} alignItems={'center'}>
          <FDBox width={'120px'}>
            <FDStack direction={'column'} alignItems={'flex-end'} justifyContent="flex-start">
              <FDTitleText value={'National Avg.'} />
              <Typography color={'textSecondary'} variant={'h6'}>{nationalAPY}</Typography>
            </FDStack>
          </FDBox>
          <div style={{ flex: 1 }}>
            <LinearProgress
              ProgressProps={{
                variant: 'determinate',
                value: 100 / apyRatio,
                classes: {
                  colorPrimary: classes.nationalAverageBarColorPrimary,
                  barColorPrimary: classes.nationalAverageBarBarColorPrimary,
                },
              }}
            />
          </div>
          <FDBox><FDTitleText size={'sm'} value={USDCurrencyFullFormatterNoFraction.format(resource.attr('interestEarnedNationalAverage'))} /></FDBox>
        </FDStack>
      </FDBox>
    </FDStack>
  );
}

OurInterestComparedWithNationalAverage.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
